import React, { useState } from 'react';
import { makeStyles } from '@material-ui/styles';
import {  Typography } from '@material-ui/core';
import { ChatOutlined, PersonOutline, PhoneAndroidOutlined } from '@mui/icons-material';
import { ExpandLess, ExpandMore } from '@mui/icons-material';

const useStyles = makeStyles((theme) => ({

  rowInfo: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'start',
    alignItems: 'start',
    backgroundColor: theme.palette.background.grey,
    borderRadius: "0.5rem",
    padding: theme.spacing(1.5),
  },


  user: {
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingRight: theme.spacing(0.5),
    //backgroundColor:'yellow'
  },

  phone: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'start',
    alignItems: 'center',
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(0.5),
  },


  message: {
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'start',
    alignItems: 'center',
    marginTop :  theme.spacing(0.5),
    
    //backgroundColor:'yellow'
  },


 
}));




export default function ClientInfoView(props) {
  const classes = useStyles();
  const {clientInfo,strings } = props;
   

  const [open, setOpen] = useState(false)
  const handleClickMore = () => {
    setOpen(!open);
  };

  
  return (

    <div className={classes.rowInfo}>
        {clientInfo && 
        <div className={classes.user}>           
          <Typography variant='body' mx={1}   color= 'text.disabled' > {strings.client_data_title} </Typography>
          {open ? 
          <ExpandLess onClick={handleClickMore}   color= 'disabled'/> :
          <ExpandMore onClick={handleClickMore}    color= 'disabled'/>}       
        </div>
        }

        {open ?
        <div>
            {clientInfo && clientInfo.name && 
            <div className={classes.phone}>    
              <PersonOutline fontSize= 'medium' color='disabled'/>
              <Typography variant='body1' mx={1} > {clientInfo.name} </Typography>        
            </div>
            }
            {clientInfo && clientInfo.phone && 
            <div className={classes.phone}>    
              <PhoneAndroidOutlined fontSize= 'medium' color='disabled'/>
              <Typography variant='body1' mx={1} > {clientInfo.phone} </Typography>        
            </div>
            }
            {clientInfo && clientInfo.message && 
            <div className={classes.message}>    
              <ChatOutlined fontSize= 'small' color='disabled'/>
              <Typography 
                color='text.disabled'
              variant='body2'
              align='left'
                mx={1}
                sx={{
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  display: "-webkit-box",
                  WebkitLineClamp: "2",
                  WebkitBoxOrient: "vertical",
                }}>
                {clientInfo.message}
                </Typography>        
            </div>
            }
      </div>
      : ""
      }

    </div>

  );
}
